import { FunctionComponent } from "react";

import { UploadFile } from "../../../../../models/classes/upload-file.class";
import { FileUploadComponent, IFileType } from "../../../../Shared";
import { useSharedDialogState } from "../../../../Shared/Components/Dialogs/SharedDialog";
import { IManageTermsOfUseDialogState } from "./ManageTermsOfUseDialog";

interface IManageTermsOfUseDialogContentProps {
  allowedFileTypes: IFileType[];
}

export const ManageTermsOfUseDialogContent: FunctionComponent<IManageTermsOfUseDialogContentProps> = ({
  allowedFileTypes,
}: IManageTermsOfUseDialogContentProps) => {
  const { setSharedDialogState } = useSharedDialogState<IManageTermsOfUseDialogState>();

  return (
    <div className="upload-section">
      <FileUploadComponent
        allowedFileTypes={allowedFileTypes}
        isSingleFileUpload={true}
        maxConcurrentProcessedFiles={1}
        fileSizeLimitMB={10}
        onChange={(files: UploadFile[]) => {
          setSharedDialogState((previousState: IManageTermsOfUseDialogState) => ({
            ...previousState,
            termsFile: files[0] || null,
          }));
        }}
        smallFileList={true}
      />
    </div>
  );
};
